import styled from '@emotion/styled';
import React, { FC, useEffect, useRef } from 'react';
import { DropTargetMonitor, useDrop } from 'react-dnd';
import { DragTypes } from '~ComponentsImproved/TSR/Types';
import { useButton } from '~Hooks';
import { BaseButton } from '~Scenes/Handy/styles';

const ButtonWrapper = styled(BaseButton)<{ isOver: boolean }>`
  background-color: #fff;
  color: var(--colorBlueGray1300);
  width: 100%;
  box-sizing: border-box;
  ${({ isOver }) =>
    isOver &&
    `
    box-shadow: 0px 0px 5px 5px rgba(255,255,255,0.6);
  `}
`;

interface Props {
  id: string;
  name: string;
  onClick: ({ id, name }: { id: string; name: string }) => void;
}

const FloorplanButton: FC<Props> = ({ id, name, onClick }) => {
  const timer = useRef<number | undefined>();

  const [{ isOver }, drop] = useDrop({
    accept: [DragTypes.CHEQUE],
    collect: (monitor: DropTargetMonitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  const button = useButton({
    onClick: () => {
      onClick({
        id,
        name,
      });
    },
  });

  useEffect(() => {
    if (isOver) {
      timer.current = window.setTimeout(() => {
        onClick({ id, name });
      }, 800);
    } else {
      if (timer.current !== undefined) {
        window.clearTimeout(timer.current);
      }
    }

    return () => {
      if (timer.current !== undefined) {
        window.clearTimeout(timer.current);
      }
    };
  }, [isOver]);

  return (
    <ButtonWrapper {...button} ref={(node) => drop(node)} isOver={isOver}>
      {name}
    </ButtonWrapper>
  );
};

export default FloorplanButton;
